import React, { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { verifyMFA } from '../../../utils/mfa';
import lang from '../../../languages/en/en.json';
import './styles.css';

const MFAVerify = ({ visible, onClose, onSuccess }) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerifyMFA = async () => {
    if (!verificationCode) {
      message.error(lang.please_enter_the_verification_code);
      return;
    }

    setLoading(true);
    try {
      const response = await verifyMFA(verificationCode);

      if (response.data.code == 10001) {
        message.success(lang.verification_successful);
        onSuccess();
      } else {
        message.error(lang.invalid_verification_code);
      }
    } catch (error) {
      message.error(lang.failed_to_verify_MFA_code);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Two-Factor Authentication"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <div className="mfa-verify-container">
        <p>Please enter the verification code from your authenticator app:</p>
        <div className="verification-input">
          <Input
            placeholder="Enter verification code"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
          <Button type="primary" onClick={handleVerifyMFA} loading={loading}>
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MFAVerify;



// WEBPACK FOOTER //
// ./src/containers/auth/mfa-verify/index.js